<template>
    <div style="display: flex;">
        <button
            class="icon-wrapper"
            @click="handleOpenModal"
            title="Editar etiquetas"
        >
            <i class="material-icons icon">new_label</i>
        </button>

        <Modal
            v-model="isModalOpen"
            :onClose="handleCloseModal"
            :title="'Etiquetas da Venda #' + salePosition"
            :showPrimaryButton="false"
            :showSecondaryButton="false"
        >
            <article aria-label="modal-content">
                <SaleTagFormVue
                    :saleTags="saleTags"
                    :onSuccess="handleSuccess"
                    :appCode="appCode"
                    :saleId="saleId"
                />
                <section v-if="!loadingSaleTags">
                    <div class="table-tags">
                        <header>
                            <h2 class="table-title">Nome</h2>
                        </header>
                        <ul
                            aria-label="sale-associated-tags"
                            v-if="saleTags.length > 0"
                            class="list-item-wrapper"
                        >
                            <li
                                class="list-item"
                                v-for="saleTag in sortedSaleTags"
                                :key="saleTag.tag.id"
                            >
                                <span>{{ saleTag.tag.name }}</span>
                                <button
                                    class="remove-button"
                                    title="Remover"
                                    @click="() => handleRemoveSaleTag(saleTag)"
                                >
                                    <i class="material-icons">delete</i>
                                </button>
                            </li>
                        </ul>
                        <span class="empty-sale-tags-list" v-else>
                            Esta venda não possui etiquetas
                        </span>
                    </div>
                    <div class="error-wrapper" v-if="!!error">
                        <small class="error">
                            {{ error }}
                        </small>
                    </div>
                </section>
                <span class="loading-sale-tags" v-else> Carrengando as etiquetas da venda...</span>
            </article>
        </Modal>
    </div>
</template>

<script>
import SellerApi from "../../services/SellerApi";
import Button from "../Button.vue";
import Modal from "../Modal.vue";
import Select from "../Select.vue";
import SaleTagFormVue from "./components/SaleTagForm.vue";

export default {
    components: { Button, Modal, Select, SaleTagFormVue },
    props: {
        salePosition: String,
        saleId: String,
        appCode: String,
    },
    data() {
        return {
            saleTags: [],
            error: "",
            isModalOpen: false,
            removingSaleTag: false,
            loadingSaleTags: false,
        };
    },
    computed: {
        sortedSaleTags() {
            return this.saleTags.sort((a, b) =>
                a.tag.name.localeCompare(b.tag.name)
            );
        },
    },
    methods: {
        handleOpenModal() {
            this.isModalOpen = true;
            this.getSaleTags();
        },
        handleCloseModal() {
            this.isModalOpen = false;
            location.reload();
        },
        handleSuccess(newSaleTag) {
            this.saleTags.push(newSaleTag);
        },
        handleRemoveSaleTag(saleTag) {
            this.removingSaleTag = true;
            SellerApi.SaleTag.removeTag(
                this.appCode,
                this.saleId,
                saleTag.tag.id
            )
                .then(() => {
                    this.removingSaleTag = false;
                    const newTags = this.saleTags.filter(
                        ({ tag }) => tag.id !== saleTag.tag.id
                    );
                    this.saleTags = [...newTags];
                })
                .catch((err) => {
                    this.removingSaleTag = false;
                    this.error =
                        "Ocorreu um erro enquanto removiamos a etiqueta da venda";
                });
        },
        getSaleTags() {
            this.loadingSaleTags = true;
            SellerApi.SaleTag.getTags(this.appCode, this.saleId)
                .then((res) => {
                    this.loadingSaleTags = false;
                    this.saleTags = res;
                })
                .catch((err) => {
                    this.loadingSaleTags = false;
                    this.error =
                        "Ocorreu um erro ao processar as etiquetas do aplicativo";
                });
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.icon {
    text-decoration: none;
    font-size: 32px;
    margin-top: -4px;
    margin-left: -4px;
    padding: -2px;
    color: #212529;
}
.icon:hover {
    color: #56e5a6;
}
.icon-wrapper {
    border: none;
    background: none;
    cursor: pointer;
    color: #212529;
    margin-left: 8px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.remove-button {
    border: none;
    background: none;
    cursor: pointer;
    color: #212529;
    margin: 0 8px;
    padding: 0;
}
.list-item-wrapper {
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #dee2e6;
}
.list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    font-size: 14px;
    font-weight: 500;
}
.table-tags {
    border-top: 1px solid #dee2e6;
    padding-top: 8px;
}
.table-title {
    font-size: 1rem;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    padding-left: 12px;
}
.error {
    font-size: 14px;
    color: red;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.error-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.loading-sale-tags,
.empty-sale-tags-list {
    text-align: center;
    width: 100%;
    display: inline-block;
    color: #212529;
}
</style>
